import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { useUser, useSetUser } from "../../globals/UserContext";
import { useQuestion } from "../../globals/QuestionContext";
import { useAssignment } from "../../globals/AssignmentContext";
import { useHtml } from "../../globals/HtmlContext";
import { saveAnswerAction } from "../../actions/saveAnswer";
import { levenshteinGrade } from "../../utils/levenshteinGrade";
import { checklistGrade } from "../../utils/checklistGrade";

export default function SaveButton(props) {
  const html = useHtml();
  const user = useUser();
  const setUser = useSetUser();
  const assignment = useAssignment();
  const question = useQuestion();
  let answer = question?.answer;

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAssignments = () => {
    handleClose();
    props.setPage("classInfo");
  };

  const handleClasses = () => {
    handleClose();
    props.setPage("classes");
  };

  const handleSave = () => {
    if (question.grading_type === "checklist") {
      const testResults = checklistGrade(question.checklist);
      let correct = 0;
      for (let corr of testResults) {
        if (corr) {
          correct++;
        }
      }
      const grade = correct / question.checklist.length;
      saveAnswerAction(
        user._id,
        assignment._id,
        question._id,
        grade,
        html,
        setUser,
        testResults
      );
      handleOpen();
    } else if (question.grading_type === "levenshtein") {
      const grade = levenshteinGrade(question.code, answer, html);
      saveAnswerAction(
        user._id,
        assignment._id,
        question._id,
        grade,
        html,
        setUser,
        [] // this is only used for checklist grading
      );
      handleOpen();
    } else {
      if (answer?.replace(/\s/g, "") === html.replace(/\s/g, "")) {
        saveAnswerAction(
          user._id,
          assignment._id,
          question._id,
          1,
          html,
          setUser,
          [] // this is only used for checklist grading
        );
        handleOpen();
      } else {
        saveAnswerAction(
          user._id,
          assignment._id,
          question._id,
          0,
          html,
          setUser,
          [] // this is only used for checklist grading
        );
        handleOpen();
      }
    }
  };

  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        onClick={handleSave}
        sx={{ marginRight: "0.5rem" }}
      >
        Save
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Slide}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          Work and score saved. Make sure to save all questions before
          submitting.
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Choose another assignment, or view classes:
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAssignments}>Assignments</Button>
          <Button onClick={handleClasses}>Classes</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
